<div [ngClass]="{ 'd-none': cookiesPresent }">
    <div class="poker-ribbon" [ngClass]="{ 'd-none': !isEnabled }">
        <span class="ui-icon theme-close-i" *ngIf="showCloseButton" (click)="closeRibbon()"></span>
        <pk-single-promo-timer
            [singlePromoTimerStyles]="stylesData"
            [singlePromoTimerRibbonData]="contentData"
            (timerStatus)="getTimerStatus($event)"></pk-single-promo-timer>
    </div>
</div>
